import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { BranchProvider, useBranch } from "./contexts/BranchContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import { LanguageProvider } from "./contexts/LanguageContext";
import Layout from "./components/Layout";
import ScrollToTop from "./components/ScrollToTop";
import BranchSelectionScreen from "./components/BranchSelectionScreen";
import HomePage from "./pages/HomePage";
import MenuPage from "./pages/MenuPage";
import GalleryPage from "./pages/GalleryPage";
import AboutPage from "./pages/AboutPage";
import FranchisePage from "./pages/FranchisePage";

function AppContent() {
  const { hasBranchSelected, setSelectedBranch } = useBranch();

  if (!hasBranchSelected) {
    return <BranchSelectionScreen onSelect={setSelectedBranch} />;
  }

  return (
    <>
      <ScrollToTop />
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/menu" element={<MenuPage />} />
          <Route path="/galeri" element={<GalleryPage />} />
          <Route path="/hakkimizda" element={<AboutPage />} />
          <Route path="/franchise" element={<FranchisePage />} />
        </Routes>
      </Layout>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <LanguageProvider>
          <BranchProvider>
            <AppContent />
          </BranchProvider>
        </LanguageProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
